var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIdentificationUnSelected(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Identification",
    xmlns: "http://www.w3.org/2000/svg",
    width: 85.187,
    height: 90.866,
    viewBox: "0 0 85.187 90.866",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_64",
    "data-name": "Path 64",
    d: "M35.909,6.833a2.84,2.84,0,0,1,0,4.021L18.872,27.892a2.84,2.84,0,0,1-4.021,0L6.332,19.373a2.843,2.843,0,1,1,4.021-4.021l6.508,6.514L31.888,6.833a2.84,2.84,0,0,1,4.021,0Z",
    transform: "translate(25.732 28.071)",
    fill: "#625656",
    fillRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_65",
    "data-name": "Path 65",
    d: "M12.358,0H69.15A11.358,11.358,0,0,1,80.508,11.358v68.15A11.358,11.358,0,0,1,69.15,90.866H12.358A11.358,11.358,0,0,1,1,79.508V73.829H6.679v5.679a5.679,5.679,0,0,0,5.679,5.679H69.15a5.679,5.679,0,0,0,5.679-5.679V11.358A5.679,5.679,0,0,0,69.15,5.679H12.358a5.679,5.679,0,0,0-5.679,5.679v5.679H1V11.358A11.358,11.358,0,0,1,12.358,0Z",
    transform: "translate(4.679)",
    fill: "#625656"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Path_66",
    "data-name": "Path 66",
    d: "M5.679,9.679V6.84a2.84,2.84,0,1,1,5.679,0v2.84H14.2a2.84,2.84,0,0,1,0,5.679H2.84a2.84,2.84,0,1,1,0-5.679Zm0,17.037v-2.84a2.84,2.84,0,0,1,5.679,0v2.84H14.2a2.84,2.84,0,1,1,0,5.679H2.84a2.84,2.84,0,1,1,0-5.679Zm0,17.037v-2.84a2.84,2.84,0,0,1,5.679,0v2.84H14.2a2.84,2.84,0,0,1,0,5.679H2.84a2.84,2.84,0,0,1,0-5.679Z",
    transform: "translate(0 18.717)",
    fill: "#625656"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIdentificationUnSelected);
export default __webpack_public_path__ + "static/media/Identification_UnSelected.3f17a9b71a34cdf3c006bdbd8a735ec1.svg";
export { ForwardRef as ReactComponent };